import { clsx } from 'clsx';

function cn(...props) {
  return clsx(props);
}

export default cn;
